<template>
	<div class="e-learning-progress">
		<div class="progress-steps">
			<p>
				<span>{{ sectionName }}:</span> pytanie:
				<span style="margin-left: 10px"
					>{{ quizStep }} / {{ allQuestions }}</span
				>
			</p>
			<p>
				pozostały czas:
				<span id="progressBar"></span>
			</p>
		</div>
		<div class="progress-bar">
			<span
				:style="{
					width: calculatedWidth(quizStep, allQuestions) + '%',
				}"
			></span>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { eLearningLessons } from '@/mixins/e-learning.js';

export default {
	data() {
		return {
			interval: '',
			timeIsOver: false,
		};
	},
	mixins: [eLearningLessons],
	computed: {
		...mapGetters(['getQuizQuestions', 'getQuestionQuiz', 'getQuizTime']),
		quizStep() {
			return this.getQuestionQuiz + 1 === 40
				? 40
				: this.getQuestionQuiz + 1;
		},
		allQuestions() {
			let numberOfQuestions = this.getQuizQuestions.length;
			numberOfQuestions === 40 ? 39 : numberOfQuestions;
			return numberOfQuestions;
		},
		sectionName() {
			let step = this.quizStep - 1;
			let questions = this.getQuizQuestions || [];
			return questions.length ? questions[step].sectionName : '';
		},
	},
	methods: {
		countDownTimer(t) {
			var countDownDate = new Date().getTime() + 60000 * this.getQuizTime;

			t.interval = setInterval(async function () {
				if (t.$checkIfSoonExpiration()) {
					await t.$store.dispatch('fetchRefreshToken');
				}

				var now = new Date().getTime();
				var distance = countDownDate - now;
				var hours = Math.floor(
					(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
				);
				var minutes = Math.floor(
					(distance % (1000 * 60 * 60)) / (1000 * 60)
				);
				var seconds = Math.floor((distance % (1000 * 60)) / 1000);
				hours = hours <= 0 ? '' : hours + ':';
				minutes = minutes <= 10 ? '0' + minutes + ':' : minutes + ':';
				seconds = seconds < 10 ? '0' + seconds : seconds;

				if (document.getElementById('progressBar')) {
					document.getElementById('progressBar').innerText =
						hours + minutes + seconds;
				}

				if (distance <= 0 && document.getElementById('progressBar')) {
					document.getElementById('progressBar').innerText = '00:00';
					clearInterval(t.interval);
					t.$store.commit('setLearningModal', true);
					t.$store.commit('setTimeIsOverModal', true);
				}
			}, 1000);
		},
	},
	created() {
		this.countDownTimer(this);
	},
	beforeUnmount() {
		clearInterval(this.interval);
	},
};
</script>
